import BaseComponent from '@/components/base';
import Style from '@/components/key-claims/style';
import { FontStyle } from '@/components/style';
import { addGlobalStylesToShadowRoot } from '@/components/global-styles';
import { StyleCta } from '@/components/style/style-cta';

export default class KeyClaims extends BaseComponent {
  onConnect() {
    addGlobalStylesToShadowRoot(this.shadowRoot);

    const current = `${window.location.href}`;

    const next = current.replace('pages/my-results', 'collections/regimen');

    const elementId = `#continueToRegimenCTA_${this.getAttribute('type')}`;

    const continueToRegimenButton = document.querySelector(elementId);

    continueToRegimenButton.addEventListener('click', () => {
      window.location.href = next;
    });
  }

  render() {
    const urlParams = new URLSearchParams(window.location.search);
    this.productType = urlParams.get('product_type') || 'core';
    return this.productType === this.getAttribute('type')
      ? `${Style({
          isMobile: this.isSmall,
          imageDesktop: this.getAttribute('imageDesktop')
        })}
      ${FontStyle}
      ${StyleCta}
      <div class="wrapper">
        <div class="main-content">
          <div class="text-content">
            <div class="title-wrapper">
              <h4 class="title-font-5 title">${this.getAttribute('title')}</h4>
            </div>
            <section class="data-claim-list">
              ${this.getAttribute('body')}
              <p class="disclaimer body-font-3">${this.getAttribute(
                'disclaimer'
              )}</p>
            </section>
          </div>
          <img class="image-mobile" src="${this.getAttribute('imageMobile')}">
        </div>
        <section class="badges">
          <img src="${this.getAttribute('badge1')}">
          <img src="${this.getAttribute('badge2')}">
          <img src="${this.getAttribute('badge3')}">
        </section>
        <slot></slot>
      </div>`
      : '';
  }
}
